// extracted by mini-css-extract-plugin
export default {"info":"Info_info__gLvf6"};